const LeftArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7.37295 12.7501L12.5422 17.9193C12.6909 18.068 12.7643 18.242 12.7625 18.4413C12.7605 18.6406 12.682 18.8179 12.527 18.9731C12.3718 19.1179 12.1961 19.1929 12 19.1981C11.8038 19.2032 11.6281 19.1282 11.473 18.9731L5.1327 12.6328C5.03904 12.5391 4.97304 12.4404 4.9347 12.3366C4.8962 12.2327 4.87695 12.1206 4.87695 12.0001C4.87695 11.8796 4.8962 11.7674 4.9347 11.6636C4.97304 11.5597 5.03904 11.461 5.1327 11.3673L11.473 5.02705C11.6115 4.88855 11.783 4.81772 11.9875 4.81455C12.192 4.81139 12.3718 4.88222 12.527 5.02705C12.682 5.18222 12.7595 5.36039 12.7595 5.56155C12.7595 5.76289 12.682 5.94114 12.527 6.0963L7.37295 11.2501H18.75C18.9628 11.2501 19.141 11.3219 19.2845 11.4656C19.4281 11.6091 19.5 11.7872 19.5 12.0001C19.5 12.2129 19.4281 12.3911 19.2845 12.5346C19.141 12.6782 18.9628 12.7501 18.75 12.7501H7.37295Z"
        fill="#525252"
      />
    </svg>
  );
};
export default LeftArrow;
